var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"col-12 pl-0 pr-0",class:_vm.customClass},[_c('v-card',{staticClass:"text-left card-styles pr-2",attrs:{"dark":"","color":"primary"}},[_c('h1',{staticClass:"headline-1 pl-3",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }